import AdminApi from '../../services/api'
import InvoicesApi from '../../services/apiInvoices'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()
const InvoiceApiService = new InvoicesApi()

export default {
    data() {
        return {
            filter: '',
            openAddOrder: false,
            openAddCuponsOrder: false,
            restaurants: [],
            types: [],
            showArchive: false,
            companyToEdit: null,
            companyToAddCupons: null,
            showLessGreen: false,
            showLessBlue: false,
            showLessWhite: false,
            usingVouchers: false,
            // pagination: {
            //     page: 1,
            //     limit: 100,
            //     totalCount: 0
            // }
        }
    },
    computed: {
        filteredUsers() {
            if(this.usingVouchers){
                return this.restaurants.filter(item => {
                    return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 &&
                        item.usingVouchers &&
                        (this.showLessGreen ? (item.vouchers.green < 5 || item.vouchers.white < 3 || item.vouchers.blue < 3) : true);

                })
            }

            return this.restaurants.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 &&
                    (this.showLessGreen ? (item.vouchers.green < 5 || item.vouchers.white < 3 || item.vouchers.blue < 3) : true);

            })
        }
    },
    methods: {
        getCompanies: getCompanies,
        deleteCompany: deleteCompany,
        editCompany: editCompany,
        openManagers: openManagers,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        visibleKey: visibleKey,
        showKey: showKey,
        onClickUser: onClickUser,
        fixArchiveInternalName: fixArchiveInternalName,
        isAdmin: isAdmin,
        openAddUserModal: openAddUserModal,
        openAllVouchers: openAllVouchers,
        getCompanyImage: getCompanyImage,
        openAddCuponsModal: openAddCuponsModal,
        updateInvoiceToken: updateInvoiceToken,
        voucherHistory: voucherHistory,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddCompany', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddCompany', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodata kompanija', 'success')
            _self.getCompanies();
        });

        this.$topnavbar.$on('closeAddCuponsCompany', () => {
            _self.companyToAddCupons = null;
            _self.openAddCuponsOrder = false;
        });
        this.$topnavbar.$on('successAddCuponsCompany', () => {
            _self.companyToAddCupons = null;
            _self.openAddCuponsOrder = false;
            swal('Uspešno', 'Uspešno dodati kuponi', 'success')
            _self.getCompanies();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.getCompanies()
        this.updateInvoiceToken();
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
        'showArchive': function (newVal) {
            this.getCompanies()
        },
    }
}

function updateInvoiceToken() {
    if(session.isInvoiceTokenExpire()){
        InvoiceApiService.signIn()
            .then((response) => {
                session.setInvoiceData(response.data)
            })
            .catch((error) => {

            })
    }
}

function openAddUserModal() {
    this.companyToEdit = null;
    this.openAddOrder = true;
}

function openAddCuponsModal(company) {
    this.companyToAddCupons = company;
    this.openAddCuponsOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getCompanies() {
    var _self = this;
    AdminApiService.getCompanies()
        .then((response) => {
             if(_self.showArchive){
                 _self.restaurants = response.data.filter(e => e.internalName.includes("_archive_"));
             }else{
                 _self.restaurants = response.data.filter(e => !e.internalName.includes("_archive_"));
             }

        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getCompanies();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}

function editCompany(company) {
    this.companyToEdit = company;
    this.openAddOrder = true;
}

function deleteCompany(user) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete kompaniju " + user.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteCompany(user.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali kompaniju', 'success')
                _self.getCompanies();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function openManagers(id, name) {
    this.$router.push('/managers?name=' + name + '&id=' + id);
}

function voucherHistory(company){
    // var c = JSON.stringify(company)
    // var encoded = window.btoa(unescape(encodeURIComponent(c)))
    // this.$router.push('/voucher-history?name=' + company.name + '&id=' + company.id + '&company=' + encoded);
    //izmenjeno kodovanje
    const c = JSON.stringify(company);
    const encoded = window.btoa(unescape(encodeURIComponent(c)));

    this.$router.push(
        '/voucher-history' +
        '?name=' + encodeURIComponent(company.name) +
        '&id=' + encodeURIComponent(company.id) +
        '&company=' + encodeURIComponent(encoded)
    );
}

function visibleKey() {
    return localStorage.getItem('sb95') === 'braca'
}

function showKey(company){
    swal('Info', 'Api Key: <b>'+ company.apiKey +'</b>', 'warning')
}

function getCompanyImage(company){
    if(company.profileImageUrl == null) return '';
    return company.profileImageUrl + '?' + new Date().getTime();
}

function isAdmin(){
    return session.getRole() === 'ADMIN'
}

function fixArchiveInternalName(name){
    return name.replace("_archive_", " (ARHIVA)")
}

function openAllVouchers(){
    this.$router.push('/voucher-history');
}


// WEBPACK FOOTER //
// ./src/components/Company/Company.js